import "@/App.css";
import "leaflet/dist/leaflet.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AppShell from "./components/AppShell";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Forgot from "./pages/Forgot";
import Scan from "./pages/Scan";
import CatchLog from "./pages/CatchLog";
import CatchDetail from "./pages/CatchDetail";
import Spots from "./pages/Spots";
import SpotDetail from "./pages/SpotDetail";
import Leaderboard from "./pages/Leaderboard";
import Profile from "./pages/Profile";

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center" data-testid="app-loading">
    <div className="font-display text-[#FF4D00] text-xl uppercase animate-pulse">Casting…</div>
  </div>
);

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function GuestOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user) return <Navigate to="/scan" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<GuestOnly><Landing /></GuestOnly>} />
          <Route path="/login" element={<GuestOnly><Login /></GuestOnly>} />
          <Route path="/signup" element={<GuestOnly><Signup /></GuestOnly>} />
          <Route path="/forgot" element={<Forgot />} />
          <Route element={<Protected><AppShell /></Protected>}>
            <Route path="/scan" element={<Scan />} />
            <Route path="/log" element={<CatchLog />} />
            <Route path="/log/:id" element={<CatchDetail />} />
            <Route path="/spots" element={<Spots />} />
            <Route path="/spots/:id" element={<SpotDetail />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/profile" element={<Profile />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" toastOptions={{ className: "rounded-none border-2 border-[#FF4D00] font-mono" }} />
    </AuthProvider>
  );
}

export default App;
